import React from 'react';
import Input from 'js/components/Common/FormComponents/Input/Input';
import classes from './StatusItem.module.pcss';

interface Props {
    id: string,
    statusCallback: Function,
    checked?: boolean
}

const StatusItem = ({id, statusCallback, checked = false}: Props) => (
    <div className={classes.Status}>
        <Input
            withLabel={true}
            type={'checkbox'}
            id={id}
            slug={id}
            name={id}
            checked={checked}
            onChange={statusCallback}
            labelText={!checked ? 'Mark As Completed' : 'Completed'}
            value={id} />
        <span></span>
    </div>
);

export default StatusItem;
